import { ComponentIds, HierarchyUtils, SnapUtils, ViewerObjectComponent, } from "@inter-ikea-core/core";
import { getConnectorsComponent } from "./componentGetters";
import { CONNECTOR_DOESNT_EXISTS } from "../constants/errors";
import { VIEWER_OBJECT_CONNECTOR } from "../constants/connectorKeys";
const viewerObjectConnectionKey = "viewer-object-connector";
/**
 * Get the size of the section entity to know how big the viewerObject should be
 * @param sectionEntity
 * @returns
 */
const getSectionSizeVector = (sectionEntity) => {
    var _a;
    const sectionSize = (_a = sectionEntity.getComponent(ComponentIds.COMMUNICATION_SIZE_COMPONENT_ID)) === null || _a === void 0 ? void 0 : _a.size.vector;
    if (!sectionSize)
        throw new Error("Entity is missing CommunicationSizeComponent: " + sectionEntity);
    return sectionSize;
};
/**
 * Create and add the actuall viewerObject to the entity
 * @param section
 * @param entity
 * @param core
 */
export const addViewerObjectToEntity = (section, entity, core) => {
    var _a, _b;
    const existingViewerObject = (_a = entity.getComponent(ComponentIds.VIEWER_OBJECT_COMPONENT_ID)) === null || _a === void 0 ? void 0 : _a.viewerObject;
    // If the entity already has a viewerObject, this will first delete it
    // This ensures that the entity has a viewerObject connected to the correct section
    if (existingViewerObject) {
        existingViewerObject.deleteObject();
    }
    const sectionSizeVector = getSectionSizeVector(section);
    const viewerObject = (_b = core.modules
        .viewer()) === null || _b === void 0 ? void 0 : _b.createBox(sectionSizeVector.X, sectionSizeVector.Y, 1, section);
    if (!viewerObject)
        return null;
    viewerObject.registerInputEvents();
    viewerObject.setTransparency(0);
    entity.addComponent(new ViewerObjectComponent(viewerObject));
};
/**
 * This will update the viewerObject to point to the correct section
 * @param entity
 * @param core
 */
export const updateViewerObject = (entity, core) => {
    const parentEntity = HierarchyUtils.parent(entity);
    if (parentEntity)
        addViewerObjectToEntity(parentEntity, entity, core);
};
/**
 * Get all the connections that the viewerObject can get attached to
 * @param entity
 * @returns
 */
const getViewerObjectConnections = (entity) => {
    var _a;
    const connections = (_a = entity.getComponent(ComponentIds.CONNECTORS_COMPONENT_ID)) === null || _a === void 0 ? void 0 : _a.connectors;
    const viewerObjectConnections = connections === null || connections === void 0 ? void 0 : connections.filter((connection) => connection.key.includes(viewerObjectConnectionKey));
    return viewerObjectConnections;
};
/**
 * Creates a viewerObjectEntity and snaps it to the section
 * @param sectionEntity
 * @param core
 * @param viewerObjectName
 */
export const createInteractableViewerObject = (sectionEntity, core, viewerObjectName) => {
    const viewerObjectConnections = getViewerObjectConnections(sectionEntity);
    if (viewerObjectConnections) {
        viewerObjectConnections.forEach((connection) => {
            var _a;
            const viewerObjectEntity = core.services.productManager.createEntity(viewerObjectName);
            if (!viewerObjectEntity)
                return;
            addViewerObjectToEntity(sectionEntity, viewerObjectEntity, core);
            const guestConnector = getConnectorsComponent(viewerObjectEntity).getConnectorByKey(VIEWER_OBJECT_CONNECTOR);
            const hostConnector = getConnectorsComponent(sectionEntity).getConnectorByKey(connection.key);
            if (!hostConnector || !guestConnector)
                throw new Error(CONNECTOR_DOESNT_EXISTS);
            (_a = SnapUtils.getSnap(viewerObjectEntity, guestConnector, sectionEntity, hostConnector)) === null || _a === void 0 ? void 0 : _a.performMoveAndConnect();
        });
    }
};
/**
 * When 'undo' removes the entity that the ViewerObject is attached to,
 * the ViewerObject needs to be manually deleted
 * @param stateBeforeLoadingSnapshot
 */
export const handleViewerObjectOnUndo = (stateBeforeLoadingSnapshot) => {
    const viewerObjectComponent = stateBeforeLoadingSnapshot.getComponent(ComponentIds.VIEWER_OBJECT_COMPONENT_ID);
    if (!viewerObjectComponent)
        return;
    viewerObjectComponent.viewerObject.deleteObject();
};
/**
 * When 'redo' adds an entity that should have the ViewerObject,
 * the viewerObject needs to be manully add back
 * @param entity
 * @param core
 * @param viewerObejctName
 */
export const handleViewerObjectOnRedo = (entity, core, appId) => {
    const parentEntityComponent = entity.getComponent(ComponentIds.CHILD_COMPONENT_ID);
    if (!parentEntityComponent)
        return;
    const parentEntity = parentEntityComponent.parent;
    if (!entity.hasComponent(ComponentIds.VIEWER_OBJECT_COMPONENT_ID) &&
        isSectionType(parentEntity, core, appId)) {
        addViewerObjectToEntity(parentEntity, entity, core);
    }
};
/**
 * Check if an entity contains 'section' in the Type data
 * @param entity
 * @param core
 * @param appId
 * @returns
 */
export const isSectionType = (entity, core, appId) => {
    var _a, _b, _c;
    const productRef = (_a = entity.getComponent(ComponentIds.PRODUCT_COMPONENT_ID)) === null || _a === void 0 ? void 0 : _a.productRef;
    if (!productRef)
        return;
    const catalog = core.services.productManager.catalogs.find((catalog) => catalog.rangeId().toLowerCase() === appId.toLowerCase());
    if (!catalog)
        return;
    const isSectionType = (_c = (_b = catalog
        .findProductDTO(productRef)) === null || _b === void 0 ? void 0 : _b.type) === null || _c === void 0 ? void 0 : _c.includes("section");
    return isSectionType;
};
